export const validateNaturalStateInscription = (value: string): boolean => {
  if (!value) return false;

  const cleanValue = value.replace(/[^\dXx]/g, '');

  if (cleanValue.length < 7 || cleanValue.length > 10) return false;

  const rgRegex = /^[0-9]{1,2}\.?[0-9]{3}\.?[0-9]{3}-?[0-9Xx]$/;

  return rgRegex.test(value);
};
